import React from 'react';
import { useRoles } from '@/app/pages/users/components/UserPane/Connectable.hooks';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Field } from 'formik';
import CustomCheckbox from '@/app/pages/users/components/UserPane/components/CustomCheckbox';
import { FormControl } from '@material-ui/core';

export const RolesTab = () => {
    const roles = useRoles();
    return (
        <FormControl component="fieldset">
            <FormGroup>
                {roles?.map((role) => (
                    <FormControlLabel
                        key={role.id}
                        control={
                            <Field
                                name={`roles.${role.id}`}
                                component={CustomCheckbox}
                            />
                        }
                        label={role.name}
                    />
                ))}
            </FormGroup>
        </FormControl>
    );
};
